import ObexRequestsHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { buildQuery, unwrapRecordOrObject, unwrapError } from './apiUtils';

// Endpoints públicos: se usan antes de iniciar sesión, así que no llevan access_token.
const ROUTES = {
  request: '/password_recovery_request',
  confirm: '/password_recovery_confirm'
};

/** Reglas de ChangePasswordModal: 8+ caracteres, una letra y un número o símbolo. */
export const isValidNewPassword = (pwd: string): boolean =>
  pwd.length >= 8 && /[A-Za-z]/.test(pwd) && /[^A-Za-z]/.test(pwd);

const run = async (route: string, params: Record<string, string>, fallback: string): Promise<void> => {
  const res = await ObexRequestsHandlerP80.get(`${route}${buildQuery(params)}`);
  const out = unwrapRecordOrObject(res);
  if (!out || !out.message) throw new Error(unwrapError(res, fallback));
};

/** Pide un código de recuperación por correo. Responde igual exista o no el usuario. */
export const requestPasswordRecovery = (identifier: string): Promise<void> =>
  run(ROUTES.request, { identifier: identifier.trim() }, 'No se pudo solicitar el código.');

/** Cambia la contraseña con el código recibido por correo. */
export const confirmPasswordRecovery = (identifier: string, code: string, newPassword: string): Promise<void> =>
  run(ROUTES.confirm, { identifier: identifier.trim(), code: code.trim(), new_password: newPassword }, 'No se pudo restablecer la contraseña.');
